const state = {
  sidebarShow: 'responsive'
};

export default {
  state
};
